__webpack_require__.p = "/StudyEasy/";